import React from 'react';

import { ApolloConsumer } from 'react-apollo';
import getOrgMemberships from '../api/getOrgMemberships';
import getOrganisationByAlias from '../api/getOrganisationByAlias';
import AuthorisationProviderComponent from '../components/AuthorisationProvider';
import RequestProvider from '../../RequestProvider';
import withPublicLink from '../../WithPublicLink';





function AuthorisationProvider({ children }) {
  return (
    <RequestProvider
      requests={{
        getOrgMemberships: getOrgMemberships(),
        getOrganisationByAlias: getOrganisationByAlias()
      }}>

      {(requests) =>
      <ApolloConsumer>
          {(apiClient) =>
        <AuthorisationProviderComponent apiClient={apiClient} {...requests}>
              {children}
            </AuthorisationProviderComponent>}

        </ApolloConsumer>}

    </RequestProvider>);

}

export default withPublicLink(AuthorisationProvider);